import React, { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { History } from 'lucide-react';

const LABELS = {
  login_success: 'Inicio de sesión', login_failed: 'Contraseña incorrecta', mfa_challenge: 'Código de doble factor solicitado',
  mfa_failed: 'Código de doble factor incorrecto', mfa_enabled: 'Doble factor activado', mfa_disabled: 'Doble factor desactivado',
  mfa_manage_failed: 'Intento fallido de cambiar el doble factor', recovery_codes_regenerated: 'Nuevos códigos de recuperación',
  password_reset: 'Contraseña restablecida', data_export: 'Exportación de datos', dpa_accepted: 'Contrato de tratamiento de datos aceptado',
};
const BAD = ['login_failed', 'mfa_failed', 'mfa_manage_failed'];

export const AuditLog = ({ scope = 'me', refreshKey = 0 }) => {
  const { api } = useAuth();
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get(`/security/audit-log?scope=${scope}`).then((r) => setEvents(r.data.events)).catch(() => setEvents([])); }, [api, scope, refreshKey]);

  return (
    <div data-testid={`audit-log-${scope}`}>
      <div className="flex items-center gap-2 mb-3 text-sm font-semibold"><History className="w-4 h-4 text-blue-400" /> {scope === 'all' ? 'Actividad de seguridad de la plataforma' : 'Tu actividad de seguridad'}</div>
      {events === null ? <p className="text-sm text-slate-500">Cargando…</p> : !events.length ? <p className="text-sm text-slate-500">Sin eventos aún.</p> : (
        <ul className="divide-y divide-slate-800 max-h-80 overflow-y-auto pr-1">
          {events.map((e) => (
            <li key={e.id} className="py-2 grid gap-0.5 text-sm sm:grid-cols-[1fr_auto] sm:gap-3" data-testid="audit-log-row">
              <span className={BAD.includes(e.event) ? 'text-rose-300' : 'text-slate-200'}>
                {LABELS[e.event] || e.event}{e.meta?.factor && e.meta.factor !== 'password' ? ` · ${e.meta.factor}` : ''}{e.email ? ` · ${e.email}` : ''}
              </span>
              <span className="text-xs text-slate-500 font-mono">{new Date(e.created_at).toLocaleString('es-CL')} · {e.ip || '—'}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
